import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.scss";
import ROUTES from "./routes/routes";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./redux/store";
import { getTranslations } from "./redux/Slices/dictionarySlice";
import { fetchSocialAccounts } from "./redux/Slices/socialAccountsSlice";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const router = createBrowserRouter(ROUTES, {
  future: { v7_startTransition: true } as any,
});

function App() {
  const theme = useSelector((state: RootState) => state.theme.mode);
  const dispatch = useDispatch<AppDispatch>();

  // Apply dark mode class on body
  useEffect(() => {
    document.body.classList.toggle("dark", theme === "dark");
  }, [theme]);

  // Load social accounts (translations are loaded by Header based on language)
  useEffect(() => {
    dispatch(fetchSocialAccounts());
  }, [dispatch]);

  return (
    <div className="App">
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme === "dark" ? "dark" : "light"}
      />
    </div>
  );
}

export default App;
